export default [
    {
        path: '/activate-account/:token',
        name: 'Activate Account',
        component: () => import('@/views/manage-account'),
        meta:
        {
            auth: false,
            page: 'activation',
        }
    },
    {
        path: '/reset-password/:token',
        name: 'Reset Password',
        component: () => import('@/views/manage-account'),
        meta:
        {
            auth: false,
            page: 'reset-password',
        }
    },
];



// WEBPACK FOOTER //
// ./src/views/manage-account/route.js